import gql from "graphql-tag";

export const GROUPS_NODE_REPORT_QUERY = gql`
  query groupsReportQuery($type: String, $afterDateYesterday: Date!, $afterDateWeek: Date!, $afterDateTotal: Date!) {
    groups(type: $type) {
      edges {
        node {
          id
          title
          type
          memberCount
          totalPostCountYesterday: totalPostCount(afterDate: $afterDateYesterday)
          totalPostCountWeek: totalPostCount(afterDate: $afterDateWeek)
          totalPostCountTotal: totalPostCount(afterDate: $afterDateTotal)
          totalCommentCountYesterday: totalCommentCount(afterDate: $afterDateYesterday)
          totalCommentCountWeek: totalCommentCount(afterDate: $afterDateWeek)
          totalCommentCountTotal: totalCommentCount(afterDate: $afterDateTotal)
          totalLikeCountYesterday: totalLikeCount(afterDate: $afterDateYesterday)
          totalLikeCountWeek: totalLikeCount(afterDate: $afterDateWeek)
          totalLikeCountTotal: totalLikeCount(afterDate: $afterDateTotal)
        }
      }
    }
  }
`;
